import React, { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { Header as StyledHeader } from '../../ContentSystem.shared.styles';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
/**
 * Represents the header component of the content system.
 *
 * @component
 * @param lightHexCode - The hex code for the light color of the header. Defaults to white.
 * @param children - The content to be rendered inside the header.
 * @param headerMaxLineLength - The max width of the text.
 */
var Header = function (_a) {
    var lightHexCode = _a.lightHexCode, children = _a.children, headerMaxLineLength = _a.headerMaxLineLength;
    var typography = useContext(ThemeContext).typography;
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    return (React.createElement(StyledHeader, { lightHexCode: lightHexCode, styleSettings: typography === null || typography === void 0 ? void 0 : typography.h2, headerMaxLineLength: headerMaxLineLength, "$styleQueryMode": styleQueryMode }, children));
};
export default Header;
